import { render, staticRenderFns } from "./loginLayout.vue?vue&type=template&id=468b30ea&scoped=true"
import script from "./loginLayout.vue?vue&type=script&lang=js"
export * from "./loginLayout.vue?vue&type=script&lang=js"
import style0 from "./loginLayout.vue?vue&type=style&index=0&id=468b30ea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "468b30ea",
  null
  
)

export default component.exports